import { 
    saveStorage, 
    loadStorage, 
    getDefaultAppConfig, 
    resetAppConfig, 
    loadConfig, 
    loginUser, 
    logoutUser, 
    getDefaultStripesWidthIndex, 
    getDefaultShapePositions, 
    getDefaultShapeColors, 
    getShapePalette, 
    getInitShapes 
} from './IConfigUtils';
import { User } from '../components/User';
import { Shape } from '../components/Shape';

describe('IConfigUtils - Pełne Pokrycie', () => {
    
    beforeEach(() => {
        localStorage.clear();
        // Mockowanie window.location.search jeśli potrzeba
        delete (window as any).location;
        window.location = { search: '?config=default' } as any;
        (window as any).config = { version: "1.0.0" }; // Mock IEnvironmentConfig
    });

    describe('Storage Operations', () => {
        it('powinien zapisywać i wczytywać logo w formacie Base64', () => {
            const config = getDefaultAppConfig();
            const base64Logo = "data:image/png;base64,TEST";
            config.startLogoLeft.src = base64Logo;
            
            saveStorage(config, 'default');
            const loaded = loadStorage(false);
            expect(loaded.startLogoLeft.src).toBe(base64Logo);
        });

        it('powinien wczytywać domyślne ustawienia gdy storage jest pusty', () => {
            const loaded = loadStorage(false);
            expect(loaded.timer).toBe(300);
        });

        it('resetAppConfig powinien przywracać wartości domyślne', () => {
            const config = getDefaultAppConfig();
            config.timer = 999;
            saveStorage(config, 'default');
            
            resetAppConfig();
            const loaded = loadStorage(false);
            expect(loaded.timer).toBe(300);
        });

        it('loadConfig powinien łączyć środowisko i aplikację', () => {
            (window as any).config = { version: "1.0.0" };
            const combined = loadConfig();
            expect(combined.environment.version).toBe("1.0.0");
            expect(combined.application.timer).toBe(300);
        });
    });

    describe('User Management', () => {
        it('loginUser powinien zalogować admina przy poprawnych danych', () => {
            const result = loginUser("admin", "cruzdiezadmin123!");
            expect(result.status).toBe(true);
            expect(result.user.name).toBe("admin");
            expect(result.user.isLogged).toBe(true);
        });

        it('loginUser powinien odrzucić błędne hasło', () => {
            const result = loginUser("admin", "wrong");
            expect(result.status).toBe(false);
            expect(result.textStatus).toBe("incorrectLoginDetails");
        });

        it('loginUser powinien wymagać podania danych', () => {
            const result = loginUser("", "");
            expect(result.status).toBe(false);
            expect(result.textStatus).toBe("pleaseEnterLoginDetails");
        });

        it('logoutUser powinien wylogować zalogowanego użytkownika', () => {
            const user = User.create(true, 1, "admin");
            const result = logoutUser(user);
            expect(result).toBe(true);
            expect(user.isLogged).toBe(false);
        });

        it('logoutUser powinien zwrócić false dla nieprawidłowego użytkownika', () => {
            const user = new User(); // pusty user bez ID
            const result = logoutUser(user);
            expect(result).toBe(false);
        });
    });

    describe('Helpers / Mappers', () => {
        it('getDefaultStripesWidthIndex powinien zwracać poprawny indeks', () => {
            const arr = [0.2, 0.5, 0.8];
            expect(getDefaultStripesWidthIndex(arr, 0.5)).toBe(1);
            expect(getDefaultStripesWidthIndex(arr, 1.0)).toBe(-1);
        });

        it('getDefaultShapePositions powinien mapować tablicę na obiekty ShapePosition', () => {
            const raw = [
                { id: 0, left: 10, top: 20 },
                { id: 1, left: 30, top: 40 },
                { id: 2, left: 50, top: 60 }
            ];
            const positions = getDefaultShapePositions(raw);
            expect(positions.length).toBe(3);
            expect(positions[0].left).toBe(10);
            expect(positions[1].top).toBe(40);
        });

        it('getDefaultShapeColors powinien tworzyć instancję ShapeColors', () => {
            const raw = ["#FF0000", "#00FF00"];
            const colors = getDefaultShapeColors(raw);
            expect(colors.colors).toEqual(raw);
        });

        it('getShapePalette powinien poprawnie tworzyć obiekty Shape', () => {
            const raw = [{
                name: "test", fileName: "test.svg", title: "Test", tagName: "rect",
                r: 0, rx: 0, ry: 0, cx: 0, cy: 0, width: 100, height: 100, rotate: 0, defaultRotate: 0, fill: "#000"
            }];
            const palette = getShapePalette(raw);
            expect(palette[0]).toBeInstanceOf(Shape);
            expect(palette[0].name).toBe("test");
        });

        it('getInitShapes powinien poprawnie tworzyć początkowe kształty', () => {
            const raw = [{
                name: "init", fileName: "init.svg", title: "Init", tagName: "circle",
                r: 50, rx: 0, ry: 0, cx: 50, cy: 50, width: 100, height: 100, rotate: 0, defaultRotate: 0, fill: "#FFF"
            }];
            const shapes = getInitShapes(raw);
            expect(shapes[0]).toBeInstanceOf(Shape);
            expect(shapes[0].tagName).toBe("circle");
        });
    });
});
